export const CONSENT_CHECKBOX_TESTID = 'enrollment-consent-checkbox';
export const CONTACT_SALES_BUTTON_TESTID = 'enrollment-contact-sales-button';
export const CONTINUE_BUTTON_TESTID = 'enrollment-continue-button';

export const PRIVACY_POLICY_URL =
  'https://www.getclearing.co/legal/privacy-policy';
export const TERMS_OF_SERVICE_URL =
  'https://www.getclearing.co/legal/terms-of-service';
